// 运营统计表
<template>
  <div class="threeLevelMain">
    <!-- 头部查询区域 -->
    <div class="queryBox clearfix">
      <div class="query_row">
        <div class="btn_box">
          <el-button
            size="mini"
            @click="exportClick"
            v-if="userId == 2 || userId == 1 || department == 7"
            style="margin-left: 20px"
            >导出统计表</el-button
          >
        </div>
      </div>
    </div>

    <!-- 内容 -->
    <tablePageComp
      :columnsList="columnsList"
      :dataList="dataList"
      :orderNumConfig="{
        fixed: true,
      }"
      :getDataConfig="dataQueryFunc()"
      :updateDataSignObj="{ updateDataTag, resetPageNum }"
      @setResetPageNum="(e) => (resetPageNum = e)"
    >
      <el-table-column slot="remark" width="200" label="备注">
        <template slot-scope="scope">
          <div class="remark-content">
            <el-tooltip effect="light">
              <div style="max-width: 200px" slot="content">
                {{ scope.row.operation_remark }}
              </div>
              <div class="text ellipsis">{{ scope.row.operation_remark }}</div>
            </el-tooltip>

            <div class="edit-handle">
              <el-popover
                placement="right"
                width="300"
                trigger="click"
                @show="() => (remarkEditShow = scope.row.operation_remark)"
              >
                <div class="t-r">
                  <el-input
                    type="textarea"
                    :rows="5"
                    v-model="remarkEditShow"
                  ></el-input>
                  <el-button
                    class="mt-5"
                    type="primary"
                    size="mini"
                    @click="editRemark(scope.row)"
                  >
                    保存
                  </el-button>
                </div>

                <el-button type="text" slot="reference">
                  <i class="el-icon-edit"></i>
                </el-button>
              </el-popover>
            </div>
          </div>
        </template>
      </el-table-column>
    </tablePageComp>

    <div class="dialog_box">
      <listExportXlsx
        :exportDataAll="exportDataAll"
        :exportClickTag="exportClickTag"
        @getApiParams="getApiParamsFunc"
        apiName="exportCensusList"
        :defaultSelected="exportDataAll.filter((item) => item.default)"
      ></listExportXlsx>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import utils from "@/libs/utils.js";
export default {
  data() {
    let d = utils.sessionGetStore("department");

    return {
      department: d,

      //表格内容相关
      dataList: [], //表格数据列表
      columnsList: [
        {
          label: "姓名",
          prop: "name",
          fixed: true,
        },
        {
          label: "品牌数",
          prop: "brand_count",
          width: 100,
          // fixed: true
        },
        // {
        //   label:"客户数",
        //   prop:'c_count'
        // },
        {
          label: "金额",
          prop: "amount_money",
          width: 100,
          formatter: (row) => {
            return Number(row).toLocaleString();
          },
          // fixed: true
        },
        {
          slotName: "remark",
        },
        {
          label: "小组金额",
          prop: "group_amount_money",
          width: 100,
          formatter: (row) => {
            return Number(row).toLocaleString();
          },
        },

        {
          label: "人均",
          prop: "per_capita",
          width: 100,
          formatter: (row) => {
            return Number(row).toLocaleString();
          },
        },
        {
          label: "2W以下",
          prop: "two",
          width: 100,
          formatter: (row) => {
            return Number(row).toLocaleString();
          },
        },
        {
          label: "2W-3W",
          prop: "three",
          width: 100,
          formatter: (row) => {
            return Number(row).toLocaleString();
          },
        },
        {
          label: "3W-5W",
          prop: "five",
          width: 100,
          formatter: (row) => {
            return Number(row).toLocaleString();
          },
        },
        {
          label: "5W-10W",
          prop: "high_five",
          width: 100,
          formatter: (row) => {
            return Number(row).toLocaleString();
          },
        },
        {
          label: "10W以上",
          prop: "high_ten",
          width: 100,
          formatter: (row) => {
            return Number(row).toLocaleString();
          },
        },
        {
          label: "1次/月",
          prop: "oneMonth_frequency",
          width: 100,
        },
        {
          label: "2次/月",
          prop: "twoMonth_frequency",
          width: 100,
        },
        {
          label: "3次/月",
          prop: "threeMonth_frequency",
          width: 100,
        },
        {
          label: "1次/周",
          prop: "oneWeek_frequency",
          width: 100,
        },
        {
          label: "2次/周",
          prop: "twoWeek_frequency",
          width: 100,
        },
        {
          label: "1次/日",
          prop: "oneDay_frequency",
          width: 100,
        },
        {
          label: "其他",
          prop: "other_frequency",
          width: 100,
        },
        {
          label: "续签品牌数",
          prop: "r_brand_count",
          width: 100,
          // fixed: true
        },
        {
          label: "续签金额",
          prop: "r_amount_money",
          width: 100,
          formatter: (row) => {
            return Number(row).toLocaleString();
          },
        },
        {
          label: "小组续签金额",
          prop: "r_group_amount_money",
          width: 100,
          formatter: (row) => {
            return Number(row).toLocaleString();
          },
        },
        {
          label: "分期数量",
          prop: "stages_count",
          width: 100,
        },
      ],
      // 主动跟新数据标记
      updateDataTag: false,
      resetPageNum: true,
      // 数据总条数
      // totalCount: 0,
      userId: "", //用户id
      userName: "", //用户名

      exportDataAll: [
        {
          chinese: "姓名",
          english: "name",
          default: true,
        },
        {
          chinese: "品牌数",
          english: "brand_count",
          default: true,
        },
        {
          chinese: "金额",
          english: "amount_money",
          default: true,
        },
        {
          chinese: "小组金额",
          english: "group_amount_money",
          default: true,
        },
        {
          chinese: "人均",
          english: "per_capita",
          default: true,
        },
        {
          chinese: "2W以下",
          english: "two",
          default: true,
        },
        {
          chinese: "2W-3W",
          english: "three",
          default: true,
        },
        {
          chinese: "3W-5W",
          english: "five",
          default: true,
        },
        {
          chinese: "5W-10W",
          english: "high_five",
          default: true,
        },
        {
          chinese: "10W以上",
          english: "high_ten",
          default: true,
        },
        {
          chinese: "1次/月",
          english: "oneMonth_frequency",
        },
        {
          chinese: "2次/月",
          english: "twoMonth_frequency",
        },
        {
          chinese: "3次/月",
          english: "threeMonth_frequency",
        },
        {
          chinese: "1次/周",
          english: "oneWeek_frequency",
        },
        {
          chinese: "2次/周",
          english: "twoWeek_frequency",
        },
        {
          chinese: "1次/日",
          english: "oneDay_frequency",
        },
        {
          chinese: "其他",
          english: "other_frequency",
        },
        {
          chinese: "续签品牌数",
          english: "r_brand_count",
        },
        {
          chinese: "续签金额",
          english: "r_amount_money",
        },
        {
          chinese: "小组续签金额",
          english: "r_group_amount_money",
        },
        {
          chinese: "分期数量",
          english: "stages_count",
        },
      ],
      exportClickTag: false, //
      remarkEditShow: "", //备注编辑显示
    };
  },
  created() {
    //获取用户id
    this.userId = utils.sessionGetStore("user_id");
    this.userName = utils.sessionGetStore("user_name");

    //  花花、怒发及技术部可访问
    if (this.userId != 2 && this.userId != 1 && this.department != 7) {
      this.$message({ type: "warning", message: "暂无权访问" });
      return;
    }
  },

  methods: {
    editRemark(row) {
      let paramObj = {
        user_id: row.user_id,
        operation_remark: this.remarkEditShow,
      };
      this.$api
        .editCensusRemark(paramObj)
        .then(() => {
          this.updateDataTag = !this.updateDataTag;
          this.resetPageNum = false;
        })
        .catch((err) => {
          console.log(err);
          this.$message.error("备注编辑失败");
        });
    },
    //  导出统计表
    exportClick() {
      this.exportClickTag = !this.exportClickTag;
    },
    getApiParamsFunc(callBack) {
      let param = {
        excel: 1,
      };
      callBack(param);
    },
    //表格数据获取
    dataQueryFunc() {
      //查询条件
      let paramObj = {};
      return {
        apiName: "exportCensusList",
        // paramObj:paramObj,
        success: function (response, callBack) {
          //  花花及技术部可访问
          if (this.userId != 2 && this.userId != 1 && this.department != 7) {
            return;
          }
          let records = response.data.data.list;
          let personInfo = this.$store.state.personInfo;

          let arr = [];
          const postArr = ["12", "13", "14"]; // 运营店长 初级店长  运营专员 小组金额和人均金额不显示
          records.forEach((item) => {
            let info = personInfo.filter((p) => p.id == item.user_id)[0];
            if (
              postArr.includes(info.post) &&
              item.name != "汪娟" &&
              item.name != "技术部"
            ) {
              item.group_amount_money = "";
              item.per_capita = "";
            }
            arr.push(item);
          });

          // 数据列表---更新
          this.dataList = arr;
          // 数据总条数---更新
          // this.totalCount = response.data.data.totalCount//接口返回的数据总条数

          // 回调函数
          if (callBack) {
            callBack();
          }
        }.bind(this),
        failed: function (error, callBack) {
          // 回调函数
          if (callBack) {
            callBack();
          }
        },
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.threeLevelMain {
  .queryBox {
    margin-bottom: 2px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    position: relative;

    // 实际服务金额
    .cooperation_amount {
      display: flex;
      align-items: center;
      justify-content: center;
      > div {
        margin: 0 !important;
      }
    }
    .activeBtn {
      position: absolute;
      top: 15px;
      right: 50px;
    }
  }

  .tabComtent {
    background: #fff;
    height: 100%;
  }

  .totalAmount {
    position: absolute;
    width: 300px;
    // background: red;
    bottom: 25px;
    right: 20px;

    > p {
      font-size: 16px;
      font-weight: 500;
      > span {
        font-size: 16px;
        color: #409eff;
      }
    }
  }

  .remark-content {
    display: flex;
    align-items: center;
    .text {
      flex: 1;
    }
    .edit-handle {
      width: 20px;
      margin-left: 10px;
    }
  }
}

.demo-ruleForm {
  > h3 {
    font-size: 16px;
    text-align: center;
    padding: 20px 0;
    color: #409eff;
    letter-spacing: 1px;
  }
  > div {
    padding: 20px;
    display: flex;
    justify-content: left;
    flex-wrap: wrap;
    .formItems {
      width: 30%;
    }
  }
}
</style>
